controllers.controller('AccountsTransferController', [
    '$scope', '$state', '$ionicLoading', '$ionicHistory', 'LocaleService', 'UserService', 'constants', 'API', 'ErrorService', 'Utils',
    function ($scope, $state, $ionicLoading, $ionicHistory, LocaleService, UserService, Const, API, ErrorService, Utils) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.constants = Const;
        $scope.transfer = {
            accountFrom: '',
            accountTo: '',
            value: 0
        };

        $scope.config = {
            digits: $scope.user.currencyDigits,
            step: 1,
            min: 1,
            max: 100000
        };
        $scope.accountFromConfig = {
            type: 'transferFrom'
        };
        $scope.accountToConfig = {
            type: 'balance'
        };
        $scope.accounts = $scope.user.tradingAccounts
            .filter(function (account) {
                return account.live
            })
            .map(function (account) {
                var currencySymbol = Const.currencySymbols[account.currency],
                    balance = account.balance.toFixed($scope.user.currencyDigits),
                    fundsToWithdraw = Math.min(account.freeMargin - account.credit, account.balance);
                account.fundsToWithdraw = fundsToWithdraw > 0 ? fundsToWithdraw : 0;
                account.description = [account.login, 'LIVE', $scope.translation.balance, currencySymbol, balance].join(' ');
                return account;
            });

        $scope.accountsFrom = $scope.accounts.filter(function (account) {
            return account.balance > 0
        });

        if ($scope.accountsFrom.length > 0) {
            //if active account is live - make it selected in list
            $scope.transfer.accountFrom = $scope.user.activeTradingAccount.live ? $scope.user.activeTradingAccount : $scope.accountsFrom[0];
        } else {
            $scope.transfer.accountFrom = null;
        }

        $scope.accountsTo = $scope.accounts.filter(function (account) {
            return $scope.transfer.accountFrom && (account.login !== $scope.transfer.accountFrom.login)
        });

        if ($scope.accountsTo.length > 0) {
            $scope.transfer.accountTo = $scope.accountsTo[0];
        } else {
            $scope.transfer.accountTo = null;
        }

        var accountWatch = $scope.$watch('transfer.accountFrom', function (newVal, oldVal) {
            if (newVal && newVal.login !== oldVal.login) {
                $scope.updateAccountsTo();
            }
        });

        $scope.updateAccountsTo = function () {
            log('model change', $scope.transfer.accountFrom.login);
            $scope.accountsTo = $scope.accounts.filter(function (account) {
                return account.login !== $scope.transfer.accountFrom.login
            });

            if ($scope.accountsTo.length > 0) {
                $scope.transfer.accountTo = $scope.accountsTo[0];
            } else {
                $scope.transfer.accountTo = null;
            }

            //reset amount
            $scope.transfer.value = 0;

            log($scope.accountsFrom);
            log($scope.accountsTo);
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'AccountsTransferController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.submit = function (form) {
            if (!form.$valid) return;
            var request = {
                from: $scope.transfer.accountFrom.login,
                to: $scope.transfer.accountTo.login,
                amount: parseInt($scope.transfer.value, 10)
            };

            if ($scope.constants['platformSelect'] || $scope.constants['customerTypeForTA']) {
                request.fromTradingPlatform = $scope.transfer.accountFrom.tradingPlatform;
                request.toTradingPlatform = $scope.transfer.accountTo.tradingPlatform;
            }
            $ionicLoading.show();
            return API.transfer(request)
                .then(checkResponse)
                .then(Utils.wait(1000))
                .then(function (response) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.transferSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.actionText = LocaleService.translation.continue;
                    $scope.modal.textContent = '';
                    $scope.modal.back = 'root.app.manageAccounts';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.transferFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        function clear() {
            accountWatch();
            $ionicHistory.clearHistory();
        }

        $scope.$on('$ionicView.beforeLeave', clear);
        $scope.$on('clear', clear);
    }]);
